import { render, staticRenderFns } from "./AddressesFilters.vue?vue&type=template&id=06a46440&"
import script from "./AddressesFilters.vue?vue&type=script&lang=js&"
export * from "./AddressesFilters.vue?vue&type=script&lang=js&"
import style0 from "./AddressesFilters.vue?vue&type=style&index=0&id=06a46440&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports